import { memo } from 'react';
import styled from 'styled-components';

/**
 * Badge component that renders its (hopefully simple) children
 * in a simple box. The component does nothing with positioning
 * and should therefore be positioned somehow where it is used.
 */
const Badge = styled.span`
	background-color: rgba(var(--base-04, var(--base-08)), 1);
	border-radius: 3px;
	color: rgba(var(--base-02, var(--base-02)), 1);
	font: var(--small-bold);
	padding: 1px 4px 0 4px;
	word-break: keep-all;
	display: flex;
	justify-content: center;
	align-items: center;
	text-transform: uppercase;
`;

export const BadgeRounded = memo(styled(Badge)`
	border-radius: 6px;
	padding: 8px 6px;
	height: 16px;
	min-width: 16px;
	max-width: 48px;
`);

export const BadgePrimary = memo(styled(Badge)`
	background-color: var(--badge-primary-bg, rgba(var(--primary), 1));
	color: var(--badge-primary-text, rgba(var(--base-02), 1));
`);

export const BadgeNew = memo(styled(Badge)`
	background-color: var(--badge-new-bg, rgba(var(--primary), 1));
	color: var(--badge-new-text, rgba(var(--base-02), 1));
`);

export const BadgeHot = memo(styled(Badge)`
	background-color: var(--hot-bg);
	color: var(--badge-new-text, rgba(var(--base-02), 1));
`);

export const BadgeDark = memo(styled(Badge)`
	background-color: var(--badge-dark-bg);
	color: var(--badge-dark-text);
`);

export const WeSpinBadge = memo(styled(Badge)`
	border-radius: 2px;
	padding: 0 4px;
	background-color: var(--badge-dark-bg);
	color: var(--badge-dark-text);
	display: inline-flex;
	justify-content: center;
	align-items: center;

	svg {
		height: 16px;
		width: 16px;
		display: inline-block;
		margin-top: -1px;
	}
`);

export const BadgeRoundedPrimary = memo(styled(BadgeRounded)`
	background-color: var(--badge-primary-bg, rgba(var(--primary), 1));
	color: var(--badge-primary-text, rgba(var(--base-02), 1));
`);

export const BadgeRoundedSecondary = memo(styled(BadgeRounded)`
	background-color: var(--badge-secondary-bg, rgba(var(--secondary-light), 1));
	color: var(--badge-secondary-text, rgba(var(--base-02), 1));
`);

export const BadgeContainer = styled.div`
	&.badge-container--lobby {
		max-width: 250px;
		position: absolute;
		top: 0;
		right: 0;
		display: flex;
		flex-direction: row;
		flex-wrap: wrap;
		justify-content: flex-end;
		padding: 4px;
		span {
			margin: 0 0 4px 4px;
		}
	}
`;

export const BadgeRainbow = memo(styled(Badge)`
	background: linear-gradient(
		to bottom,
		rgb(238, 78, 79) 16.6%,
		rgb(255, 174, 77) 16.6% 33.2%,
		rgb(254, 242, 77) 33.2% 49.8%,
		rgb(77, 166, 103) 49.8% 66.4%,
		rgb(77, 130, 255) 66.4% 83%,
		rgb(159, 81, 171)
	);
	color: rgb(22, 22, 29);
`);
